//@flow
import React, { useState } from 'react';
import 'semantic-ui-css/components/button.min.css';
import 'semantic-ui-css/components/grid.min.css';
import 'semantic-ui-css/components/container.min.css';
import 'semantic-ui-css/components/accordion.min.css';
import 'semantic-ui-css/components/icon.min.css';
import 'semantic-ui-css/components/placeholder.min.css';
import 'semantic-ui-css/components/input.min.css';
import 'semantic-ui-css/components/checkbox.min.css';
import 'styles/global.module.css';
import 'styles/index.css';
import { compose } from 'recompose';
import { Route, Switch, withRouter } from 'react-router';
import { Home, NotFound, NotEntitled, Manage, Transfer } from 'routes';
import { Helmet } from 'react-helmet';
import ReactGA from 'react-ga';
import { useDispatch, useSelector } from 'react-redux';
import { fetchApplicationContent, fetchCustomerType, fetchToggles } from 'actions/app.actions';
import Loading from 'components';
import Error from 'views/Error';
import TransferFailed from 'views/Error/TransferFailed';
import api from '../../api';

import { errorLogger, getImsiFromPostData } from '../../helpers';
import { isComviqCustomer } from '../../helpers/customerTypeHelpers';

const isNumber = (imsiString) => imsiString && !isNaN(imsiString);

const App = () => {
  const [showLoader, setShowLoader] = useState(true);
  const [missingMsi, setMissingmsi] = useState(false);
  const customerType = useSelector((state) => state.app.customerType);
  const isComviq = isComviqCustomer(customerType);

  ReactGA.initialize('UA-12442609-32');
  ReactGA.pageview('/');
  const dispatch = useDispatch();

  React.useEffect(() => {
    try {
      dispatch(fetchToggles());
      // dispatch(fetchApplicationContent());//ta bort
      const imsi = getImsiFromPostData();

      window.__IMSI__ = imsi;
      api
        .getMsisdn({ imsi })
        .then((msisdn) => {
          if (isNumber(msisdn)) {
            window.__MSISDN__ = msisdn;
            dispatch(fetchCustomerType({ msisdn }));
          } else {
            errorLogger({ name: 'client-app-js', log: 'Error, missing msisdn: ' + msisdn });
            setMissingmsi(true);
          }
        })
        .finally(() => {
          setShowLoader(false);
        });
    } catch (error) {
      setShowLoader(false);
      errorLogger({ name: 'client-app-js', log: `Fetching initial data failed: ${error.message}` });
    }
  }, []);

  if (showLoader) return <Loading />;
  if (missingMsi) return <Error message="Msisdn saknas" />;
  return (
    <div id={isComviq ? 'comviq' : 'tele2'}>
      <Helmet>
        <title>Tilläggsabonnemang för klocka - Tele2</title>
      </Helmet>
      <Switch>
        <Route exact path="/manageAccount" component={Manage} />
        <Route exact path="/transfer/:iccid?/:imsi?/:eid?" component={Transfer} />
        <Route exact path="/transfer-failed" component={TransferFailed} />
        <Route exact path="/:imsi?/:eid?" component={Home} />
        <Route exact path="/not-entitled" component={NotEntitled} />
        <Route component={NotFound} />
      </Switch>
    </div>
  );
};

export default compose(withRouter)(App);
